import { createApp } from "vue";
import Router from "@/router/Router";
import MaatOntwikkeling from "@/MaatOntwikkeling.vue";

createApp(MaatOntwikkeling).use(Router).mount("#maatontwikkeling");
